import { render, staticRenderFns } from "./SearchHistoryList.vue?vue&type=template&id=07dcd8cd&scoped=true&"
import script from "./SearchHistoryList.vue?vue&type=script&lang=ts&"
export * from "./SearchHistoryList.vue?vue&type=script&lang=ts&"
import style0 from "./SearchHistoryList.vue?vue&type=style&index=0&id=07dcd8cd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07dcd8cd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07dcd8cd')) {
      api.createRecord('07dcd8cd', component.options)
    } else {
      api.reload('07dcd8cd', component.options)
    }
    module.hot.accept("./SearchHistoryList.vue?vue&type=template&id=07dcd8cd&scoped=true&", function () {
      api.rerender('07dcd8cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "module/Deals/view/vue/components/lists/SearchHistoryList.vue"
export default component.exports